import type { ReactNode } from 'react';
import React from 'react';

import * as styles from './Tabs.styles';

interface Tab {
  active: boolean;
  content: ReactNode;
  href: string;
  label: string;
}

interface TabsProps {
  ariaLabel?: string;
  tabs: Tab[];
}

function getTabId(href: string): string {
  return href.replace(/^#/, '');
}

export const Tabs = ({ ariaLabel, tabs }: TabsProps) => {
  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role */}
      <nav aria-label={ariaLabel} css={styles.tabList} role="tablist">
        {tabs.map((tab) => {
          const id = getTabId(tab.href);
          return (
            <a
              aria-controls={`panel-${id}`}
              aria-current={tab.active ? 'page' : undefined}
              aria-selected={tab.active}
              css={styles.tabLink}
              href={tab.href}
              key={`link-${id}`}
              role="tab"
            >
              {tab.label}
            </a>
          );
        })}
      </nav>
      <>
        {tabs.map((tab) => {
          const id = getTabId(tab.href);
          return (
            <section
              aria-current={tab.active ? 'page' : undefined}
              aria-labelledby={`tab-${id}`}
              css={styles.tabPanel}
              id={`panel-${id}`}
              key={`panel-${id}`}
              role="tabpanel"
              tabIndex={tab.active ? 0 : -1}
            >
              {tab.content}
            </section>
          );
        })}
      </>
    </>
  );
};
